import { Container, ContainerOptions } from "pixi.js";
import { DEFAULT_CURRENT_JACKPOT } from "../StaticConfig";
import gsap from "gsap";
import GlobalStore from "../services/GlobalStore";
import { CommonEvents } from "../events/EventEnums";
import { CurrentJackpotValue } from "../models/JackpotCurValue";
import { Odometer } from "./odometer/Odometer";

class CurrentJackpots extends Container {
  private jackpotValues: Map<number, Odometer> = new Map();

  private showTimeline: gsap.core.Timeline | undefined;
  private hideTimeline: gsap.core.Timeline | undefined;

  constructor(containerOptions?: ContainerOptions) {
    super(containerOptions);

    const config = DEFAULT_CURRENT_JACKPOT;
    const fontFamily: string = "Faustina";

    console.log("CurrentJackpots config:", config);
    console.log("Using font family:", fontFamily);

    this.alpha = 0;

    for (const jpDef of config.jackpots) {
      console.log(jpDef);

      let odometer = new Odometer({
        digitCount: 10,
        fontFamily: "Faustina",
        fontSize: jpDef.size,
        formatter: (value: number) => GlobalStore.formatCurrency(value),
        // spacing: -10,
        maxWidth: 1500,
      });
      odometer.contentAnchor = { x: 0.5, y: 0.5 };
      odometer.x = jpDef.x;
      odometer.y = jpDef.y;
      // odometer.anchor.set(0.5, 0.5);
      this.addChild(odometer);
      this.jackpotValues.set(
        GlobalStore.getJackpotIdOverride() ?? jpDef.id,
        odometer,
      );
    }

    this.addEventListeners();
  }

  updateValues = ({
    values,
    duration = undefined,
  }: {
    values: CurrentJackpotValue[];
    duration?: number;
  }): void => {
    this.jackpotValues.keys().forEach((key) => {
      const v = values.find((it) => {
        return Number(`${it.code}`) === Number(key);
      });

      if (v === undefined) return;

      // We know odometer exists as we got the key as argument in foreach
      const odometer = this.jackpotValues.get(key) as Odometer;

      console.log(
        `New Value ${v.value} - cur Value ${odometer.getValue()}`,
        v.value - odometer.getValue(),
      );
      if (v.value - odometer.getValue() > 10) {
        odometer.fastSpin(v.value, {
          duration: duration ?? 0.25,
          extraSpins: 0,
        });
      } else {
        odometer.rotateTo(v.value, {
          duration: duration ?? 0.25, //duration ?? 0.0,
          easing: "none",
        });
      }
    });
  };

  show = (delay: number = 0): void => {
    console.log("CurrentJackpots showing with delay", delay);

    if (this.hideTimeline) {
      this.hideTimeline.pause(0);
    }

    if (!this.showTimeline) {
      this.showTimeline = gsap.timeline();

      const optsStart = {
        alpha: 0,
      };

      const opts = {
        duration: 0.5,
        delay: delay,
        alpha: 1,
      };

      console.log("CurrentJackpots creating show timeline with options", opts);

      this.showTimeline.add([gsap.fromTo(this, optsStart, opts)]).call(() => {
        // this.jackpotValues.keys().forEach((key) => {
        //   const odometer = this.jackpotValues.get(key);
        //   odometer?.rotateTo(odometer.getValue(), {
        //     duration: 0,
        //     easing: "none",
        //   });
        // });
      });
    }

    this.showTimeline.play(0);
  };

  hide = (delay: number = 0): void => {
    console.log("CurrentJackpots hiding with delay", delay);

    if (!this.hideTimeline) {
      this.hideTimeline = gsap.timeline();

      const optsStart = {
        alpha: 1,
      };

      const opts = {
        duration: 0.5,
        delay: Math.max(0, delay - 0.5),
        alpha: 0,
      };

      console.log("CurrentJackpots creating hide timeline with options", opts);

      this.hideTimeline.add([gsap.fromTo(this, optsStart, opts)]);
    }

    this.hideTimeline.play(0);
  };

  hideInstant = (): void => {
    console.log("CurrentJackpots hideInstant()");
    if (this.alpha === 0) {
      return;
    }

    this.showTimeline?.pause(0);
    this.hideTimeline?.pause(0);

    this.alpha = 0;
  };

  private addEventListeners = () => {
    const commonEE = GlobalStore.commonEventEmitter;

    commonEE.on(CommonEvents.CHANGE_LANGUAGE, this.updateLanguage);
  };

  private removeEventListeners = () => {
    const commonEE = GlobalStore.commonEventEmitter;

    commonEE.off(CommonEvents.CHANGE_LANGUAGE, this.updateLanguage);
  };

  private updateLanguage = (): void => {
    console.log("CurrentJackpots updateLanguage()");
  };
}

export default CurrentJackpots;
